<section class="add-address">
	<section class="add-address__content">
		<button class="add-address__close-btn" (click)="onCloseSelectAddress()">
			<i class="bi bi-x-circle"></i>
		</button>
		<h2 class="add-address__title">
			Ingresa los datos de tu nueva dirección de entrega
		</h2>
		<form
			class="add-address__form"
			[formGroup]="addressForm"
			(ngSubmit)="onSubmitAddress()">
			<div class="item-form">
				<i class="bi bi-signpost icon black bg-gray"></i>
				<input
					class="form-control bg-gray"
					type="text"
					id="street"
					name="street"
					placeholder="Ingresa tu calle"
					formControlName="street"
					[ngClass]="{
						'--invalid': streetField.invalid && streetField.dirty,
						'--valid': streetField.valid && streetField.dirty
					}"
					#street />
			</div>
			<span
				*ngIf="streetField.touched && streetField.errors"
				class="add-address__form__input-error">
				Este campo es requerido
			</span>
			<div class="form-row-inputs">
				<div class="item-form">
					<i class="bi bi-signpost icon black bg-gray"></i>
					<input
						class="form-control bg-gray"
						type="text"
						id="exteriorNumber"
						name="exteriorNumber"
						placeholder="No. interior"
						formControlName="exteriorNumber"
						[ngClass]="{
							'--invalid':
								exteriorNumberField.invalid && exteriorNumberField.dirty,
							'--valid': exteriorNumberField.valid && exteriorNumberField.dirty
						}"
						#exteriorNumber />
				</div>
				<div class="item-form">
					<i class="bi bi-signpost icon black bg-gray"></i>
					<input
						class="form-control bg-gray"
						type="text"
						id="interiorNumber"
						name="interiorNumber"
						placeholder="No. exterior"
						formControlName="interiorNumber"
						[ngClass]="{
							'--invalid':
								interiorNumberField.invalid && interiorNumberField.dirty,
							'--valid': interiorNumberField.valid && interiorNumberField.dirty
						}"
						#interiorNumber />
				</div>
			</div>
			<span
				*ngIf="exteriorNumberField.touched && exteriorNumberField.errors"
				class="add-address__form__input-error">
				Este campo es requerido
			</span>
			<div class="item-form">
				<i class="bi bi-signpost icon black bg-gray"></i>
				<input
					class="form-control bg-gray"
					type="text"
					id="postalCode"
					name="postalCode"
					placeholder="Código postal"
					formControlName="postalCode"
					(keyup)="onPostalCodeChange()"
					[ngClass]="{
						'--invalid': postalCodeField.invalid && postalCodeField.dirty,
						'--valid': postalCodeField.valid && postalCodeField.dirty
					}"
					#postalCode />
			</div>
			<span
				*ngIf="postalCodeField.touched && postalCodeField.errors?.['required']"
				class="add-address__form__input-error">
				Este campo es requerido
			</span>
			<span
				*ngIf="postalCodeField.touched && postalCodeField.errors?.['exactLengthRegex']"
				class="add-address__form__input-error">
				Codigo postal deber ser de 5 digitos
			</span>
			<div class="item-form">
				<i class="bi bi-pin-map icon black bg-gray"></i>
				<select
					class="form-control bg-gray"
					id="colonyId"
					name="colonyId"
					formControlName="colonyId"
					[ngClass]="{
						'--invalid': colonyIdField.invalid && colonyIdField.dirty,
						'--valid': colonyIdField.valid && colonyIdField.dirty
					}"
					#colony>
					<option class="option" value="" selected disabled>Colonia</option>
					<option
						*ngFor="let colonie of colonies"
						class="option"
						[ngValue]="colonie.value">
						{{ colonie.description }}
					</option>
				</select>
			</div>
			<div
				class="d-flex justify-content-left mr-3 mb-3"
				*ngIf="isSearchColonyLoading">
				<div class="spinner-border spinner-border-sm text-secondary"></div>
			</div>
			<span
				*ngIf="colonyIdField.touched && colonyIdField.errors?.['exactLengthRegex']"
				class="add-address__form__input-error">
				Este campo es obligatorio
			</span>
			<button class="add-address__form__button" type="submit">
				Guardar dirección<i class="bi bi-chevron-right"></i>
			</button>
		</form>
	</section>
</section>
